import dayjs from 'dayjs';

// Helpers de formato compartidos.

// Moneda en pesos argentinos (es-AR). null/undefined → '—'.
//
// SIN decimales, y no es cosmético: `toLocaleString` por defecto muestra hasta
// tres, mientras que el Excel (`'"$"#,##0'`) y el PDF (`f'${v:,.0f}'`) redondean
// a cero. Un promedio que no divide exacto salía "$10.000.000,333" en pantalla
// y "$10.000.000" en el archivo — el mismo número con dos caras, justo en el
// resumen que el productor le lleva impreso al cabañero.
export const money = (v) => (v == null
  ? '—'
  : `$${Number(v).toLocaleString('es-AR', { maximumFractionDigits: 0 })}`);

// Fecha argentina, dd/mm/aaaa. null/undefined/'' o invalida → '—'.
//
// POR QUE EXISTE, SI YA HAY `dayjs(v).format('DD/MM/YYYY')` EN 5 LUGARES:
// no es por el formato —dayjs ya lo hace bien, y tampoco tiene el corrimiento
// de dia de `new Date('2026-08-15')`, porque no delega en el parser del spec—.
// Es por el vacio:
//
//     dayjs(undefined).format('DD/MM/YYYY')  ->  26/08/2026   (HOY)
//
// Sin error, sin aviso: un campo vacio pinta la fecha de hoy como si fuera un
// dato real. En una app de remates eso es una fecha de arranque falsa en
// pantalla, y falla silencioso — no tira, muestra otro numero.
//
// El guard va ANTES de que dayjs vea el valor, porque `dayjs(undefined)` es
// valido. `dayjs(null)` si es invalido, pero se cubren los dos igual para no
// depender de esa asimetria.
export const fecha = (v) => {
  if (v == null || v === '') return '—';
  const d = dayjs(v);
  return d.isValid() ? d.format('DD/MM/YYYY') : '—';
};
